import React, { useState, useEffect } from "react";
import "../App.css";
import SelectClientes from "./SelectClientes";
import GlobalFunctions from "../Services/GlobalFunctions";
import Swal from "sweetalert2";
import DialogoLoading from "../Components/DialogoLoading";
import axios from "axios";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

export default function NewLista(params) {
  const glob = new GlobalFunctions();
  const [screenSm, setScreenSm] = useState(false);
  const [filterClientes, setFilterClientes] = useState([]);
  const [cartera, setCartera] = useState(null);
  const [item, setItem] = useState({
    id: 0,
    cliente: "",
    clienteCedula: "", //Valor opcional para ingreso automatico al sistema
    valor: "",
  });
  const [value, setValue] = React.useState("");
  const [mostrarLista, setMostrarLista] = useState([]);
  const [totales, setTotales] = useState({
    totalCobrado: 0,
    totalGastos: 0,
    efectivoNeto: 0,
  });
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition,
  } = useSpeechRecognition();
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (window.screen.width < 600) {
      setScreenSm(true);
    }
  }, []);

  useEffect(() => {
    cargarClientes();
    if (cartera != null) {
      cargarListaByCartera();
    }
  }, [cartera]);

  useEffect(() => {
    cargarCarteraPrede();
  }, [params.carteras]);

  useEffect(() => {
    if (!listening && transcript) {
      // Si no está escuchando Y hay una transcripción
      if (item.cliente == "") {
        setItem((valores) => ({
          ...valores,
          cliente: transcript,
        }));
      } else {
        if (item.valor == "") {
          setItem((valores) => ({
            ...valores,
            valor: transcript,
          }));
        }
      }
      if (transcript == "ingresar") {
        agregarRegistro();
      }
    }
  }, [listening, transcript]);

  function cargarCarteraPrede() {
    if (params.carteras.length > 0) {
      const cookieCarteraPrede = glob.getCookie("cartera_prede");
      if (cookieCarteraPrede != "") {
        setCartera(cookieCarteraPrede);
      } else {
        setCartera(params.carteras[0]);
      }
    }
  }

  function getMicrofono() {
    document.getElementById("btnIniciarMicrofono").click();
  }

  function stopMicrofono() {
    document.getElementById("btnDetenerMicrofono").click();
  }

  const handleKeyDown = (event) => {
    // Verificar si la tecla presionada es "Enter" (código 13 o 'Enter')
    if (event.key === "Enter") {
      event.preventDefault(); // Prevenir el comportamiento por defecto del navegador (ej. envío de formulario)
      agregarRegistro();
    }
  };

  if (!browserSupportsSpeechRecognition) {
    return <span>El navegador no soporta el reconocimiento de voz.</span>;
  }

  function cargarListaByCartera() {
    const list = cargarListaFromCookie().filter(
      (element) => element.cartera == cartera
    );
    setMostrarLista(list);
    totalizar(list);
  }

  function cargarListaFromCookie() {
    let list = [];
    const listaCookie = glob.getCookie("lista");
    if (listaCookie != null && listaCookie != "") {
      list = JSON.parse(listaCookie);
    }
    return list;
  }

  function totalizar(list) {
    let totalCobrado = 0;
    let totalGastos = 0;
    let efectivoNeto = 0;
    list.forEach((element) => {
      if (isNaN(element.valor)) {
      } else {
        if (element.valor != "") {
          if (element.valor < 0) {
            totalGastos += parseFloat(element.valor);
          } else {
            totalCobrado += parseFloat(element.valor);
          }
        }
      }
    });
    efectivoNeto = totalCobrado + totalGastos;
    setTotales({
      totalCobrado: totalCobrado,
      totalGastos: totalGastos,
      efectivoNeto: efectivoNeto,
    });
  }

  function cargarClientes() {
    let data = [];
    if (cartera != null) {
      //filtar por cartera
      params.clientes.forEach((element) => {
        if (element.Cobro == cartera) {
          data.push(element);
        }
      });
      setFilterClientes(data);
    }
  }

  function cambioCartera(e) {
    setCartera(e.target.value);
  }

  function getInputChange(newInputValue) {
    // se ejecuta siempre que hay cambio en el input
    setItem((valores) => ({
      ...valores,
      cliente: newInputValue,
    }));
  }

  function getOnchange(newValue) {
    // Se ejecuta al cambiar un valor del array
    if (newValue !== null) {
      setItem((valores) => ({
        ...valores,
        cliente: newValue.label,
        clienteCedula: newValue.id,
      }));
    }
  }

  function cambioValor(e) {
    // Se ejecuta al cambiar un valor del array
    setItem((valores) => ({
      ...valores,
      valor: e.target.value,
    }));
  }

  function limpiarInputs() {
    setValue("");
    setItem({
      cliente: "",
      valor: "",
      clienteCedula: "",
    });
    document.getElementById("btnEnfocarSelect").click();
  }

  function agregarRegistro() {
    if (item.cliente != "") {
      const list = cargarListaFromCookie();
      let newId = 0;
      list.forEach((element) => {
        if (element.id >= newId) {
          newId = element.id;
        }
      });
      item.id = newId + 1;
      item.cartera = cartera;
      list.push(item);
      procesarListaMostrar(list);
      limpiarInputs();
    }
  }

  function procesarListaMostrar(list) {
    //Se guarda toda la lista sin filtrar por cartera
    glob.setCookie("lista", JSON.stringify(list), 3600 * 24 * 30);
    //Se totaliza y se muestra la lista filtrada por cartera
    const listaFiltrada = list.filter((element) => element.cartera == cartera);
    totalizar(listaFiltrada);
    setMostrarLista(listaFiltrada);
  }

  function borrarRegistro(item) {
    Swal.fire({
      title: "¿Desea eliminar el registro de " + item.cliente + "?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        const newLista = cargarListaFromCookie().filter(
          (element) => element.id !== item.id
        );
        procesarListaMostrar(newLista);
      }
    });
  }

  function alertBorrarLista() {
    Swal.fire({
      title: "¿Desea eliminar toda la lista?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
    }).then((result) => {
      if (result.isConfirmed) {
        const newLista = cargarListaFromCookie().filter(
          (element) => element.cartera !== cartera
        );
        procesarListaMostrar(newLista);
      }
    });
  }

  const enviarLista = async () => {
    if (mostrarLista.length == 0) {
      sweetAlert("Lista vacía", "warning", 1000);
      return;
    }
    document.getElementById("btnOpenModalLoading").click();
    const newLista = [];
    mostrarLista.forEach((element) => {
      newLista.push(element.cliente + ": " + element.valor);
    });
    try {
      const url = API_URL + "/savelistacobrado";
      axios
        .post(url, {
          fecha: glob.getFecha(),
          total_cobrado: totales.totalCobrado,
          total_egresos: totales.totalGastos,
          total_neto: totales.efectivoNeto,
          lista: JSON.stringify(newLista),
          cartera: cartera,
        })
        .then((response) => {
          document.getElementById("btnCloseModalLoading").click();
          sweetAlert("Lista enviada correctamente.", "success", 500);
        })
        .catch((error) => {
          sweetAlert(error, "error", 2000);
          document.getElementById("btnCloseModalLoading").click();
        });
    } catch (error) {}
  };

  function sweetAlert(title, icon, time) {
    Swal.fire({
      title: title,
      icon: icon,
      timer: time,
    });
  }

  function fijarCartera() {
    glob.setCookie("cartera_prede", cartera, 3600 * 24 * 30);
  }

  function confirmarIngresoAutomatico() {
    Swal.fire({
      title: "¿Ingresar lista automaticamente al sistema?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirmar",
      confirmButtonColor: "green",
      cancelButtonColor: "gray",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        validarVaciosRegistroAuto();
      }
    });
  }

  function validarVaciosRegistroAuto() {
    let listHtml = "<ul>";
    let validarVacio = false;
    mostrarLista.forEach((element) => {
      if (element.valor == "") {
        validarVacio = true;
        listHtml += `<li>${element.cliente}</li>`;
      }
    });
    listHtml += "</ul>";
    if (validarVacio) {
      Swal.fire({
        title: "Los siguientes registros no tiene valor!",
        icon: "warning",
        html: listHtml,
        showCancelButton: true,
        confirmButtonText: "Continuar",
        confirmButtonColor: "blue",
        cancelButtonText: "Regresar a editar la lista",
        cancelButtonColor: "green",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          procesarListaRegistroAuto();
        }
      });
    } else {
      procesarListaRegistroAuto();
    }
  }

  async function procesarListaRegistroAuto() {
    let listHtml = "<h1>Este seria el resultado:</h1> <ul>";
    let validar = false;
    const nuevaLista = [];
    mostrarLista.map((element) => {
      const newElement = { ...element };
      if (newElement.valor < 1000 && newElement.valor !== "") {
        newElement.valor = element.valor * 1000;
        validar = true;
        listHtml += `<li>${element.cliente + ": " + newElement.valor}</li>`;
      }
      nuevaLista.push(newElement);
    });
    listHtml += "</ul>";
    if (validar) {
      Swal.fire({
        title: "¿Agregar ceros a los números chicos?",
        icon: "warning",
        html: listHtml,
        showCancelButton: true,
        confirmButtonText: "Ingresar con cambios.",
        confirmButtonColor: "blue",
        cancelButtonText: "Cancelar",
        cancelButtonColor: "green",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          fetchIngresoListaAutomatico(nuevaLista);
        }
      });
    } else {
      fetchIngresoListaAutomatico(mostrarLista);
    }
  }

  function fetchIngresoListaAutomatico(lista) {
    if (lista.length == 0) {
      sweetAlert("Lista vacía", "warning", 1000);
      return;
    }
    document.getElementById("btnOpenModalLoading").click();
    const url = API_URL + "/ingresoautomaticolista";
    try {
      axios
        .post(url, {
          fecha: glob.getFecha(),
          lista: lista,
        })
        .then((response) => {
          if (response.data) {
            mostrarRespuestaIngresoListaAutomatico(response.data);
          } else {
            sweetAlert(response, "error", 3000);
          }
          document.getElementById("btnCloseModalLoading").click();
        })
        .catch((error) => {
          sweetAlert(error, "error", 2000);
          document.getElementById("btnCloseModalLoading").click();
        });
    } catch (error) {}
  }

  function mostrarRespuestaIngresoListaAutomatico(data) {
    let listHtml = "<ul>";
    data.forEach((element) => {
      listHtml += `<li>${element}</li>`;
    });
    listHtml += "</ul>";
    Swal.fire({
      title: "Los registros se han ingresado, estos son los resultados:",
      icon: "success",
      html: listHtml,
      confirmButtonText: "Ok",
      confirmButtonColor: "blue",
    })
  }

  return (
    <div
      style={{
        width: screenSm ? "100%" : "40%",
        textAlign: "center",
      }}
      className="container"
    >
      <h1 className="titulo" style={{ margin: "0.4em" }}>
        Lista del dia
      </h1>
      <div className="row">
        <div className="col-9">
          <div style={{ marginLeft: "-1em" }}>
            <SelectClientes
              clientes={filterClientes}
              getOnchange={getOnchange}
              getInputChange={getInputChange}
              value={value}
              inputValue={item.cliente}
            ></SelectClientes>
          </div>
        </div>
        <div className="col-3">
          <input
            className="rounded"
            style={{
              marginLeft: "-1.5em",
              marginTop: "0.3em",
              width: "132%",
              height: "81%",
            }}
            type="number"
            value={item.valor}
            onChange={cambioValor}
            onKeyDown={handleKeyDown}
          ></input>
        </div>
      </div>
      <div
        style={{ marginTop: "0.2em", marginBottom: "0.4em" }}
        className="row "
      >
        <div
          style={{ backgroundColor: "white", height: "3em" }}
          className="col-4 rounded"
        >
          <h3 style={{ whiteSpace: "nowrap", fontSize: "1em" }}>
            Total cobrado
          </h3>
          <h3 style={{ marginTop: "0.2em", fontSize: "1em" }}>
            {glob.formatNumber(totales.totalCobrado)}
          </h3>
        </div>
        <div style={{ backgroundColor: "white" }} className="col-4 rounded">
          <h1 style={{ fontSize: "1em" }}>Total gastos</h1>
          <h1 style={{ marginTop: "0.3em", color: "red", fontSize: "1em" }}>
            {glob.formatNumber(totales.totalGastos)}
          </h1>
        </div>
        <div style={{ backgroundColor: "white" }} className="col-4 rounded">
          <h1 style={{ fontSize: "1em" }}>Efectivo neto</h1>
          <h1 style={{ marginTop: "0.2em", fontSize: "1em" }}>
            {glob.formatNumber(totales.efectivoNeto)}
          </h1>
        </div>
      </div>
      <div className="row">
        <div className="col-3">
          <button onClick={enviarLista} className="btn btn-primary">
            <span style={{ display: "flex" }}>
              Enviar
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-share"
                viewBox="0 0 16 16"
                style={{
                  marginLeft: "0.3em",
                  marginTop: "0.3em",
                }}
              >
                <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.5 2.5 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5m-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" />
              </svg>
            </span>
          </button>
        </div>
        <div className="col-6">
          <select
            onChange={cambioCartera}
            style={{
              width: "80%",
              marginLeft: "1.7em",
              height: "92%",
              padding: "0.2em",
            }}
            value={cartera}
            className="rounded"
            aria-label="Default select example"
          >
            {params.carteras.map((cartera, index) => {
              return (
                <option key={index} value={cartera}>
                  {cartera}
                </option>
              );
            })}
          </select>
        </div>
        <div className="col-3">
          <button onClick={agregarRegistro} className="btn btn-success">
            <span style={{ display: "flex" }}>
              Ok
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-floppy"
                viewBox="0 0 16 16"
                style={{
                  marginLeft: "0.3em",
                  marginTop: "0.3em",
                  color: "white",
                }}
              >
                <path d="M11 2H9v3h2z" />
                <path d="M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z" />
              </svg>
            </span>
          </button>
        </div>
        <div style={{ marginTop: "0.5em" }} className="row">
          <div className="col-4">
            <button
              onClick={alertBorrarLista}
              className="btn btn-outline-danger btn-sm"
            >
              <span style={{ display: "flex" }}>
                Reiniciar
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  className="bi bi-trash3"
                  viewBox="0 0 16 16"
                  style={{
                    color: "red",
                    marginTop: "0.1em",
                    marginLeft: "0.2em",
                  }}
                >
                  <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                </svg>
              </span>
            </button>
          </div>
          <div className="col-5">
            <button
              onClick={fijarCartera}
              type="button"
              className="btn btn-outline-info btn-sm"
              style={{ marginLeft: "0.1em" }}
            >
              <span style={{ display: "flex" }}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-clipboard-check-fill"
                  viewBox="0 0 16 16"
                  style={{
                    marginRight: "0.2em",
                    marginTop: "0.2em",
                  }}
                >
                  <path d="M6.5 0A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0zm3 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5z" />
                  <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1A2.5 2.5 0 0 1 9.5 5h-3A2.5 2.5 0 0 1 4 2.5zm6.854 7.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 0 1 .708-.708L7.5 10.793l2.646-2.647a.5.5 0 0 1 .708.708" />
                </svg>
                Fijar Cartera
              </span>
            </button>
          </div>
          <div className="col-3">
            <button
              onClick={confirmarIngresoAutomatico}
              className="btn btn-outline-primary btn-sm"
            >
              <span style={{ display: "flex" }}>
                Auto
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  className="bi bi-arrow-repeat"
                  viewBox="0 0 16 16"
                  style={{
                    color: "blue",
                    marginTop: "0.1em",
                    marginLeft: "0.2em",
                  }}
                >
                  <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9" />
                  <path
                    fillRule="evenodd"
                    d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
      <div className="table-responsive">
        <table className="table">
          <tbody>
            {mostrarLista.map((element, index) => {
              return (
                <tr key={index}>
                  <td className="align-middle">{element.cliente}</td>
                  <td className="align-middle">
                    {element.valor > 0
                      ? glob.formatNumber(element.valor)
                      : element.valor}
                  </td>
                  <td className="align-middle">
                    <button
                      onClick={() => borrarRegistro(element)}
                      className="btn btn-outline-danger"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="currentColor"
                        className="bi bi-trash3"
                        viewBox="0 0 16 16"
                        style={{
                          color: "red",
                        }}
                      >
                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" />
                      </svg>
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div
        style={{
          display: "scroll",
          position: "fixed",
          bottom: "2%",
          left: "10%",
          zIndex: 1,
          cursor: "pointer",
        }}
      >
        {listening ? (
          <button onClick={stopMicrofono} className="btn btn-danger btn-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="currentColor"
              className="bi bi-mic-mute"
              viewBox="0 0 16 16"
              style={{ color: "black" }}
            >
              <path d="M13 8c0 .564-.094 1.107-.266 1.613l-.814-.814A4 4 0 0 0 12 8V7a.5.5 0 0 1 1 0zm-5 4c.818 0 1.578-.245 2.212-.667l.718.719a5 5 0 0 1-2.43.923V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 1 0v1a4 4 0 0 0 4 4m3-9v4.879l-1-1V3a2 2 0 0 0-3.997-.118l-.845-.845A3.001 3.001 0 0 1 11 3" />
              <path d="m9.486 10.607-.748-.748A2 2 0 0 1 6 8v-.878l-1-1V8a3 3 0 0 0 4.486 2.607m-7.84-9.253 12 12 .708-.708-12-12z" />
            </svg>
          </button>
        ) : (
          <button onClick={getMicrofono} className="btn btn-success btn-sm">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="currentColor"
              className="bi bi-mic"
              viewBox="0 0 16 16"
              style={{ color: "black" }}
            >
              <path d="M3.5 6.5A.5.5 0 0 1 4 7v1a4 4 0 0 0 8 0V7a.5.5 0 0 1 1 0v1a5 5 0 0 1-4.5 4.975V15h3a.5.5 0 0 1 0 1h-7a.5.5 0 0 1 0-1h3v-2.025A5 5 0 0 1 3 8V7a.5.5 0 0 1 .5-.5" />
              <path d="M10 8a2 2 0 1 1-4 0V3a2 2 0 1 1 4 0zM8 0a3 3 0 0 0-3 3v5a3 3 0 0 0 6 0V3a3 3 0 0 0-3-3" />
            </svg>
          </button>
        )}
        <button
          onClick={SpeechRecognition.startListening}
          style={{ display: "none" }}
          id="btnIniciarMicrofono"
        ></button>
        <button
          onClick={SpeechRecognition.stopListening}
          style={{ display: "none" }}
          id="btnDetenerMicrofono"
        ></button>
      </div>
      <DialogoLoading></DialogoLoading>
    </div>
  );
}
